import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '../../infrastructure/redux/store'
import { getCompabilityBySign } from '../../infrastructure/repositories/casaArcanaRepository.ts'

export const fetchCompatibility = createAsyncThunk(
  'compatibility/fetch',
  async ({ sign1, sign2 }: { sign1: string; sign2: string }, { getState }) => {
    const state = getState() as RootState
    const baseURL = state.api.baseURL
    return await getCompabilityBySign(baseURL, sign1, sign2)
  }
)